<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Próximo Evento
  </app-header-dialog>

  <div *ngIf="entityForm">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Capa</div>
        </ng-template>

        <div class="content">

          <mat-form-field appearance="outline" style="margin-top: 10px;">
            <mat-label>Tipo de Evento</mat-label>
            <mat-select [errorStateMatcher]="matcher" [formControl]="entityForm.controls.type">
              <mat-option *ngFor="let type of types" [value]="type.id">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="entityForm.controls.type.hasError('required')">
              Selecione uma categoria
            </mat-error>
          </mat-form-field>

          <div>
            <mat-form-field style='width: 160px;' appearance="outline">
              <mat-label>Data Entrada</mat-label>
              <input matInput [matDatepicker]="pickerIn" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateIn">
              <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
              <mat-datepicker #pickerIn></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 160px; margin-left: 20px;' appearance="outline">
              <mat-label>Data Saída</mat-label>
              <input matInput [matDatepicker]="pickerOut" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateOut">
              <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
              <mat-datepicker #pickerOut></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 160px; margin-left: 20px' appearance="outline">
              <mat-label>Data Início</mat-label>
              <input matInput [matDatepicker]="pickerStart" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateStart">
              <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>

            <mat-form-field style='width: 160px; margin-left: 20px' appearance="outline">
              <mat-label>Data Término</mat-label>
              <input matInput [matDatepicker]="pickerEnd" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.dateEnd">
              <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
              <mat-datepicker #pickerEnd></mat-datepicker>
            </mat-form-field>

          </div>

          <mat-form-field style='width: 700px;' appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 700px;' appearance="outline">
            <mat-label>Coordenador</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.coordinator"
              autocomplete="off">
          </mat-form-field>

          <div>
            <mat-form-field style='width: 580px;' appearance="outline">
              <mat-label>Local</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.location"
                autocomplete="off">
            </mat-form-field>

            <mat-form-field style='width: 100px; margin-left: 20px;' appearance="outline">
              <mat-label>Horário</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.hour"
                autocomplete="off">
            </mat-form-field>
          </div>

          <mat-form-field style='width: 370px;' appearance="outline">
            <mat-label>Cidade</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.city"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 310px; margin-left: 20px;' appearance="outline">
            <mat-label>País</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.country"
              autocomplete="off">
          </mat-form-field>


          <mat-form-field style='width: 700px;' appearance="outline">
            <mat-label>Site</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.site"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 700px;' appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.email"
              autocomplete="off">
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Texto</div>
        </ng-template>

        <div class="content">

          <div style="margin-top: 20px;">
            <mat-label>Descrição</mat-label>
            <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.description" [editor]="Editor"></ckeditor>
          </div>

          <div style="margin-top: 30px;">
            <mat-label>Informação</mat-label>
            <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.information" [editor]="Editor"></ckeditor>
          </div>

        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Imagem</div>
        </ng-template>

        <div class="content">


          <div style="margin-top: 10px;">
            <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
              style="display:none;">
            <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              Selecionar imagem
            </a>
            <span style="margin: 0 20px 0 40px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
          </div>

          <div style="display: flex; justify-content: center; width: 100%; margin: 10px;">
            <img [src]="storedImage" style="width: 450px; height: 450px;" *ngIf="storedImage">
          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </div>


  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
      (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
      (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>